<template>
  <div class="body">
    <!--    <el-row style="text-align: left; margin: 1% auto;">-->
    <!--      <el-button class="body-btn" type="danger">关闭</el-button>-->
    <!--      <el-button class="body-btn" type="success">打印</el-button>-->
    <!--    </el-row>-->
    <divider/>
    <div>
      <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px">
        基本信息
      </div>
      <table class="gridtable" style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody>
          <tr>
            <td class="tableLabel">订单类型</td>
            <td class="tdContent">{{salesOrder.salesOrderCategoryName}}</td>
            <td class="tableLabel">是否超信贷</td>
            <td class="tdContent">{{salesOrder.creditStatus === 20 ? "是" : "否"}}</td>
            <td class="tableLabel">超信贷额度</td>
            <td class="tdContent">{{salesOrder.creditAmount}}</td>
          </tr>
          <tr>
            <td class="tableLabel">订单编号</td>
            <td class="tdContent">{{salesOrder.salesOrderNo}}</td>
            <td class="tableLabel">制单人</td>
            <td class="tdContent">{{salesOrder.creatorName}}</td>
            <td class="tableLabel">制单时间</td>
            <td class="tdContent">{{salesOrder.createDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">状态</td>
            <td class="tdContent">{{salesOrder.statusName}}</td>
            <td class="tableLabel">提交时间</td>
            <td class="tdContent">{{salesOrder.submitDate}}</td>
            <td class="tableLabel">ERP订单编号</td>
            <td class="tdContent">{{salesOrder.erpSalesOrderNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户合同号</td>
            <td class="tdContent">{{salesOrder.customerContractNo}}</td>
            <td class="tableLabel">项目名称</td>
            <td class="tdContent">{{salesOrder.projectName}}</td>
            <td class="tableLabel">交货日期</td>
            <td class="tdContent">{{salesOrder.deliveryDate}}</td>
          </tr>
          <tr>
            <td class="tableLabel">客户</td>
            <td class="tdContent">{{salesOrder.customerName}}</td>
            <td class="tableLabel">联系人</td>
            <td class="tdContent">{{salesOrder.contact}}</td>
            <td class="tableLabel">联系方式</td>
            <td class="tdContent">{{salesOrder.telephone}}</td>
          </tr>
          <tr>
            <td class="tableLabel">收货地址</td>
            <td class="tdContent" colspan="3">{{salesOrder.cascadesName + salesOrder.deliveryPlace}}</td>
            <td class="tableLabel">商务申请</td>
            <td class="tdContent">{{salesOrder.businessApplicationNo}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注</td>
            <td class="tdContent" colspan="5">{{salesOrder.note}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div>
      <div
          style="
            border-bottom: 1px solid #ddd;
            margin-bottom: 10px;
            padding-bottom: 5px;
            font-size: 16px;
            margin-top: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;">
        <div>订单商品</div>
        <div v-if="salesOrder.totalAmount !== 0">总金额：￥{{salesOrder.totalAmount}}</div>
        <div v-else>总金额：￥0</div>
      </div>
      <el-table ref="payData" border :data="salesOrder.materialVOS">
<!--        <el-table-column align="center" type="index" label="#" width="55"/>-->
        <el-table-column prop="materialTypeName" width="140" align="center" label="物料类型"/>
        <el-table-column align="center" prop="quantity" label="数量" width="60"/>
<!--        <el-table-column align="center" prop="unitName" label="单位" width="50"/>-->
        <el-table-column align="center" prop="price" label="单价(含税)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{scope.row.price}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="总价(含税)" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.price !== null">{{(scope.row.quantity * scope.row.price).toFixed(2)}}</span>
            <span v-else>***</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="deliveryDate" label="交货日期" width="120"/>
        <el-table-column label="确认交货日期" align="center" width="160">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.confirmDeliveryDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width: 100%"
                placeholder="请选择日期"/>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="note"
            label="备注"
            width="240"/>
        <el-table-column align="center" prop="materialNo" label="物料编号" width="150"/>
        <el-table-column
            prop="materialSpecification"
            align="left"
            min-width="250"
            show-overflow-tooltip
            label="规格型号"/>
        <el-table-column
            align="left"
            prop="materialName"
            label="物料名称"
            min-width="220"
            show-overflow-tooltip/>
      </el-table>
    </div>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <el-table ref="payData1" border :data="salesOrder.attachments">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" show-overflow-tooltip/>
        >
      </el-table>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>
<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  import constant from "@/util/constant";

  export default {
    name: "SalesOrderPreview",
    components: {HandleDetail},
    props: {
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        billId: "",
        billType: "",
        sequId: "",
        constant,
        deliveryPlace: "", // 收货地址
        nodeId: "",
        isHidden: false,
        salesOrder: {},
      };
    },
    watch: {
      $route: {
        immediate: true,
        handler(val) {
          if (val.query.billId) {
            this.billId = val.query.billId;
            this.billType = val.query.billType;
            this.sequId = val.query.sequId;
            this.getData(val.query.billId);
            this.getNodeValue();
          }
        },
      },
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    methods: {
      getData() {
        this.$emit("loading-status", {"loading": true});
        this.$http
          .get("basic", `sd/so/${this.billId}`)
          .then(resp => {
            this.$emit("loading-status", {"loading": false});
            this.salesOrder = resp.data;
          });
      },
      //获取省市区id获取三级联动
      getDeliveryPlace(id) {
        if (id > 0) {
          this.$http.get("basic", `districts/cascadename/${id}`).then((resp) => {
            console.log(resp);
            if (resp.success) {
              this.deliveryPlace = resp.data + "," + this.salesOrder.deliveryPlace;
            }
          });
        }
      },

      // 下载
      downLoad(row) {
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(row.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        });
      },

      getNodeValue() {
        let params = {
          billType: this.billType,
          billId: this.billId,
          sequId: this.sequId,
        };
        this.$http.get("basic", "applications/approve", params).then((resp) => {
          this.nodeId = resp.data.nodeId;
        });
      },

      doApprove() {
        let billParam = [];
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };

        this.$emit("loading-status", {loading: true});
        //计划确认交期
        if (this.nodeId == "PlanConfirm" && this.params.actionType === 0) {
          this.$http.post("basic", "sd/so/updateDelivery", this.salesOrder);
        }

        this.$http
          .post("basic", "applications/doApprove", params)
          .then((resp) => {
            this.$emit("loading-status", {loading: false});
            if (resp.success) {
              this.$message.success("保存成功");
              // if (["regionManager", "fiApprove", "GeneralManager"].includes(this.nodeId)) {
              //   this.updateHandle();
              // }

              // 关闭标签
              this.$bus.$emit("closeTag", this.$route);
              this.$router.push({
                path: "/workFlow/SalesOrderApplication",
              });
            }
          })
          .catch(() => {

            this.$emit("loading-status", {loading: false});
          });
      },
    },
  };
</script>
<style lang="scss">
.body {
  .el-button + .el-button {
    margin-left: 0;
  }

  .el-tabs--border-card > .el-tabs__content {
    padding: 10px;
  }

  .body-btn {
    margin-bottom: 2px;
    margin-right: 2px;
  }

  table.gridtable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-width: 1px;
    border-color: #dddddd;
    border-collapse: collapse;
    width: 100%;
  }

  table.gridtable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
    background-color: #D1E6F5;
  }

  table.gridtable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #dddddd;
  }

  .tableLabel {
    width: 10%;
    text-align: right;
    background-color: #D1E6F5;
  }
}
</style>
